import React, { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import { format, addDays } from "date-fns";
import { config, encodeBase64RequestBody, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const SubsidiaryDetail = () => {
  const { id_subcompany } = useParams();
  const [subcompany, setSubcompany] = useState(null);
  const [quotations, setQuotations] = useState(null);
  const [ious, setIous] = useState(null);
  const [licences, setLicences] = useState(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));
  const navigate = useNavigate();

  useEffect(() => {
    getSubcompany();
  }, []);

  useEffect(() => {
    if (subcompany) {
      getQuotations();
      getIous();
      getLicences();
    }
  }, [subcompany]);

  const getSubcompany = async () => {
    try {
      const requestGetSubcompany = {
        "id_subcompany": id_subcompany
      }
      const fetchGetSubcompany = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encodeBase64RequestBody(requestGetSubcompany)
      });
      const responseGetSubcompany = await fetchGetSubcompany.json();
      if (responseGetSubcompany.status === 200) {
        setSubcompany(responseGetSubcompany.data[0]);
      } else {
        alert(responseGetSubcompany.message);
      }
    } catch (error) {
      console.error('Error in getSubcompany:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getQuotations = async () => {
    try {
      const requestGetQuotation = {
        "subcompany_id": id_subcompany
      }
      const fetchGetQuotation = await jwtFetch(config.ENDPOINT + 'get/quotation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetQuotation)
      });
      const responseGetQuotation = await fetchGetQuotation.json();
      if (responseGetQuotation.status === 200) {
        setQuotations(responseGetQuotation.data);
      } else {
        alert(responseGetQuotation.message);
      }
    } catch (error) {
      console.error('Error in getQuotations:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getIous = async () => {
    try {
      const requestGetIous = {
        "subcompany_id": id_subcompany
      }
      const fetchGetIous = await jwtFetch(config.ENDPOINT + 'get/iou', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetIous)
      });
      const responseGetIou = await fetchGetIous.json();
      if (responseGetIou.status === 200) {
        setIous(
          responseGetIou.data
            .filter((iou) => (new Date(iou.start_term_period) <= addDays(new Date(), 7)) && (new Date(iou.end_term_period) >= new Date()) && iou.iou_status === 'New')
            .sort((a, b) => (a.start_term_period || '').localeCompare(b.start_term_period || '')));
      } else {
        alert(responseGetIou.message);
      }
    } catch (error) {
      console.error('Error in getIous:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getLicences = async () => {
    try {
      const requestGetLicences = {
        "subcompany_id": id_subcompany
      }
      const fetchGetLicences = await jwtFetch(config.ENDPOINT + 'get/clients_company_licence', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetLicences)
      });
      const responseGetLicence = await fetchGetLicences.json();
      if (responseGetLicence.status === 200) {
        setLicences(responseGetLicence.data.filter((licence) => licence.licence_status === 'Active'));
      } else {
        alert(responseGetLicence.message);
      }
    } catch (error) {
      console.error('Error in getLicences:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  return (
    <div id="subsidiary-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="client" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Subsidiary Detail</div>
                    {((crmUser.user_department !== 'Sales Admin' && crmUser.user_level !== 'View') && crmUser.user_level !== 'View') && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/client/subsidiary/edit/' + id_subcompany}><i className="bi bi-pencil me-1" /> Edit</button>
                    )}
                  </div>
                  {subcompany ? (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Company Group</div>
                          <div className="col-md-8">{subcompany.group_name} <a href={"/client/detail/" + subcompany.company_id}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Company Name</div>
                          <div className="col-md-8">{subcompany.company_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Legal Name</div>
                          <div className="col-md-8">{subcompany.company_billing_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Billing Address</div>
                          <div className="col-md-8">{subcompany.company_billing_address}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Mailing Address</div>
                          <div className="col-md-8">{subcompany.company_address}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Phone Number</div>
                          <div className="col-md-8">{subcompany.company_phone}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Fax</div>
                          <div className="col-md-8">{subcompany.company_fax}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Status</div>
                          <div className="col-md-8"><span className={"badge bg-" + (subcompany.company_status === 'Active' ? 'success' : 'danger')}>{subcompany.company_status}</span></div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card mb-4">
                          <div className="card-body">
                            <div className="fs-18 mb-3">NPWP</div>
                            <div className="row mb-2">
                              <div className="col-md-4 text-secondary">Number</div>
                              <div className="col-md-8">{subcompany.company_npwp_number}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-4 text-secondary">File</div>
                              <div className="col-md-8">
                                <div className="d-flex flex-wrap gap-2">
                                  {JSON.parse(subcompany.company_npwp_files) && (
                                    JSON.parse(subcompany.company_npwp_files).map((file, s) =>
                                      <iframe src={file.fileUrl} width="240" height="160" title={"Subsidiary NPWP file " + (s + 1)} key={"file-" + s} />
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

                <section className="mb-4">
                  <Tabs className="mb-3" defaultActiveKey="quotations">
                    <Tab eventKey="quotations" title="Quotations">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="fs-24">Quotation List</div>
                        {(crmUser.user_department !== 'Sales Admin' && crmUser.user_level !== 'View') && (
                          <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.open('/quotation/add/' + subcompany.company_id, '_blank')}><i className="bi bi-plus-lg me-1" /> Add</button>
                        )}
                      </div>
                      {quotations && quotations.length ? (
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="bg-primary text-light">#</th>
                                <th className="bg-primary text-light">Number</th>
                                <th className="bg-primary text-light text-center">Status</th>
                                <th className="bg-primary text-light">Created Date</th>
                                <th className="bg-primary text-light">SKUs</th>
                                <th className="bg-primary text-light text-end">Amount</th>
                                <th className="bg-primary"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {quotations
                                .sort((a, b) => {
                                  const statusOrder = ['Won', 'Open', 'Draft', 'Expire', 'Freeze', 'Lost', 'Canceled'];
                                  const aIndex = statusOrder.indexOf(a.quotation_status);
                                  const bIndex = statusOrder.indexOf(b.quotation_status);
                                  const aOrder = aIndex === -1 ? statusOrder.length : aIndex;
                                  const bOrder = bIndex === -1 ? statusOrder.length : bIndex;
                                  return aOrder - bOrder;
                                })
                                .map((quotation, q) =>
                                  <tr key={"quotation-" + quotation.id_quotation} onClick={() => window.location.href = '/quotation/detail/' + quotation.id_quotation}>
                                    <td valign="middle">{q + 1}</td>
                                    <td valign="middle">{quotation.quotation_code}</td>
                                    <td valign="middle" align="center"><span className={"badge bg-" + (quotation.quotation_status === 'Won' ? 'success' : 'secondary')}>{quotation.quotation_status}</span></td>
                                    <td valign="middle">{format(quotation.created_on, 'd MMM yyyy')}</td>
                                    <td valign="middle" title={quotation.item_list_names}>{quotation.item_list}</td>
                                    <td valign="middle" align="right">{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</td>
                                    <td valign="middle" align="right"><button type="button" className="btn btn-icon btn-outline-secondary" aria-label="View quotation"><i className="bi bi-eye" /></button></td>
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p>No data</p>
                      )}
                    </Tab>
                    <Tab eventKey="invoice-requests" title="Invoice Requests">
                      <div className="fs-24 mb-3">Invoice Request List</div>
                      {ious && ious.length ? (
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="bg-primary text-light">#</th>
                                <th className="bg-primary text-light">Due Date</th>
                                <th className="bg-primary text-light">Subsidiary</th>
                                <th className="bg-primary text-light">Quotation</th>
                                <th className="bg-primary text-light">Schedule</th>
                                <th className="bg-primary text-light text-end">Amount</th>
                                <th className="bg-primary text-light text-center">Status</th>
                                <th className="bg-primary"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {ious.map((iou, i) =>
                                <tr key={"iou-" + [i]} onClick={() => window.location.href = '/iou/detail/' + iou.id_iou}>
                                  <td valign="middle">{i + 1}</td>
                                  <td valign="middle">{format(iou.start_term_period, 'd MMM yyyy')}</td>
                                  <td valign="middle">{iou.subcompany_name}</td>
                                  <td valign="middle">{iou.quotation_code}</td>
                                  <td valign="middle">{iou.term_number.replace('Term', 'Schedule')}</td>
                                  <td valign="middle" align="right">{priceFormat(iou.iou_grand_total, iou.iou_currency)}</td>
                                  <td valign="middle" align="center"><span className="badge bg-danger text-light ms-2">Overdue</span></td>
                                  <td valign="middle" align="right"><button type="button" className="btn btn-icon btn-outline-secondary" aria-label="View invoice request"><i className="bi bi-eye" /></button></td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p>No data</p>
                      )}
                    </Tab>
                    <Tab eventKey="licences" title="Licences">
                      <div className="fs-24 mb-3">Licences List</div>
                      {licences && licences.length ? (
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="bg-primary text-light">#</th>
                                <th className="bg-primary text-light">SKU</th>
                                <th className="bg-primary text-light">Domain</th>
                                <th className="bg-primary text-light" style={{ textAlign: 'center' }}>Quantity</th>
                                <th className="bg-primary text-light" style={{ textAlign: 'center' }}>Start Date</th>
                                <th className="bg-primary text-light" style={{ textAlign: 'center' }}>End Date</th>
                                <th className="bg-primary text-light" style={{ textAlign: 'center' }}>Contract Period</th>
                                <th className="bg-primary text-light" style={{ textAlign: 'center' }}>Payment</th>
                              </tr>
                            </thead>
                            <tbody>
                              {licences.map((licence, l) =>
                                <tr key={"licence-" + [l]}>
                                  <td valign="middle">{l + 1}</td>
                                  <td valign="middle">{licence.product_name}</td>
                                  <td valign="middle">{licence.licence_domain}</td>
                                  <td align="center" valign="middle">{licence.licence_total_seat + ' Unit(s)'}</td>
                                  <td align="center" valign="middle">{format(licence.licence_start_period, 'd MMM yyyy')}</td>
                                  <td align="center" valign="middle">{format(licence.licence_end_period, 'd MMM yyyy')}</td>
                                  <td align="center" valign="middle">{licence.licence_long_period + ' Month(s)'}</td>
                                  <td align="center" valign="middle">{licence.billcycle_payment_period}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p>No data</p>
                      )}
                    </Tab>
                  </Tabs>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubsidiaryDetail;


